import { render, staticRenderFns } from "./BotCommandMessage.vue?vue&type=template&id=063ea135&"
import script from "./BotCommandMessage.ts?vue&type=script&lang=ts&"
export * from "./BotCommandMessage.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports